import { FavoriteEntityType, SchemaTypenames, TypenamesContext } from '@/generated/graphql';

export const NoCacheInvalidationContext: TypenamesContext = {
  additionalTypenames: [],
};

export const DeleteSloMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.SLO],
};

export const CreateSLOMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.SLO],
};

export const UpdateSLOMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Annotation, SchemaTypenames.SLO],
};

export const CreateCommentContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Comment],
};

export const UpdateThreadContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Comment, SchemaTypenames.Thread],
};

export const UpdateCommentContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Comment],
};

export const SoftDeleteCommentContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Comment],
};

export const CreateThreadInputContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Thread],
};

export const UpdateUserSettingsMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.UserSettings],
};

export const SaveDashboardSettingsContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.GrafanaDashboard],
};

export const DeleteNativeDashboardMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Dashboard],
};

export const SaveDashboardContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Dashboard],
};

export const DeleteGrafanaDashboardMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.GrafanaDashboard],
};

export const DuplicateDashboardContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.GrafanaDashboard],
};

export const ImportDashboardMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.GrafanaDashboard],
};

export const MigrateDashboardContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Dashboard],
};

export const CreateAlertReceiverMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.AlertReceiver],
};

export const DeleteAlertReceiverMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.AlertReceiver],
};

export const UpdateAlertReceiverMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.AlertReceiver],
};

export const DeleteNotificationPolicyMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.NotificationPolicy],
};

export const UpdateNotificationPolicyMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.NotificationPolicy],
};

export const CreateNotificationPolicyMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.NotificationPolicy],
};

export const CreateCollectionMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Collection],
};

export const DeleteCollectionMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Collection],
};

export const UpdateCollectionMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Collection, SchemaTypenames.Service],
};

export const UpdateCollectionHomepageContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.CollectionHomepage, SchemaTypenames.Link],
};

export const DeleteTeamMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Team],
};

export const CreateTeamMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Team],
};

export const UpdateTeamMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Team],
};

export const UpdateTeamHomepageContext: TypenamesContext = {
  additionalTypenames: [
    SchemaTypenames.TeamHomepage,
    SchemaTypenames.Role,
    SchemaTypenames.User,
    SchemaTypenames.Link,
    SchemaTypenames.NotificationPolicy,
  ],
};

export const BulkUpdateTeamMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Team, SchemaTypenames.User],
};

export const DeleteCollectionLinksMutationContext: TypenamesContext = {
  additionalTypenames: [
    SchemaTypenames.AllDashboardsConnection,
    SchemaTypenames.CollectionLink,
    SchemaTypenames.CollectionLinksConnection,
    SchemaTypenames.MonitorsConnection,
  ],
};

export const UpsertCollectionLinksMutationContext: TypenamesContext = {
  additionalTypenames: [
    SchemaTypenames.AllDashboardsConnection,
    SchemaTypenames.CollectionLink,
    SchemaTypenames.CollectionLinksConnection,
    SchemaTypenames.MonitorsConnection,
  ],
};

export const CreateMutingRuleMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.MutingRule],
};

export const UpdateMutingRuleMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Downtime, SchemaTypenames.MutingRule],
};

export const CreateSearchHistoryContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.UserSearchHistory],
};

export const DeleteSearchHistoryContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.UserSearchHistory],
};

export const UpdateSearchHistoryContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.UserSearchHistory],
};

export const CreateTraceSearchHistoryInputContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.TraceSearchHistory],
};

export const CreateSavedTraceSearchContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.SavedTraceSearchConnection],
};

export const UpdateSavedTraceSearchContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.SavedTraceSearchConnection],
};

export const DeleteSavedTraceSearchContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.SavedTraceSearchConnection],
};

export const CreateServiceAccountMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.ServiceAccount],
};

export const DeleteServiceAccountsMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.ServiceAccount],
};

export const ServicePresentationCreateContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.ComponentPresentationConfig],
};

export const ServicePresentationUpdateContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.ComponentPresentationConfig],
};

export const ServicePresentationDeleteContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.ComponentPresentationConfig],
};

export const RunServiceDiscoveryContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.ComponentDiscoveryConfig, SchemaTypenames.ObjectMergeRule],
};

export const ServicePresentationPanelsContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.ComponentPresentationConfig],
};

export const ApplyCurrentServiceConfigurationContext: TypenamesContext = {
  additionalTypenames: [
    SchemaTypenames.ComponentDiscoveryConfig,
    SchemaTypenames.ObjectMergeRule,
    SchemaTypenames.PresentationComponent,
    SchemaTypenames.ComponentPresentationConfig,
  ],
};

export const UpdateCustomDiscoveryContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.ComponentDiscoveryConfig],
};

export const DeleteCustomComponentContext: TypenamesContext = {
  additionalTypenames: [
    SchemaTypenames.Component,
    SchemaTypenames.ComponentDiscoveryConfig,
    SchemaTypenames.CustomComponentOutput,
  ],
};

export const CreateCustomDiscoveryContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.ComponentDiscovery],
};

export const CreateCustomDiscoveryJobContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.ComponentPresentationConfig],
};

export const CreateUserInviteMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.User],
};

export const ResendSignupInviteMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.User],
};

export const BulkUpdateTeamsForUserMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Team, SchemaTypenames.User],
};

export const UpdateFavoritesMutationContext: Record<FavoriteEntityType, TypenamesContext> = {
  [FavoriteEntityType.DASHBOARD]: { additionalTypenames: [SchemaTypenames.Dashboard] },
  [FavoriteEntityType.GRAFANA_DASHBOARD]: { additionalTypenames: [SchemaTypenames.GrafanaDashboard] },
  [FavoriteEntityType.MONITOR]: { additionalTypenames: [SchemaTypenames.Monitor] },
  [FavoriteEntityType.SLO]: { additionalTypenames: [SchemaTypenames.SLO] },
};

export const UpdateServiceAttributeMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Service],
};

export const PutDocArtifactMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.DocArtifact],
};

export const DeleteDocArtifactMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.DocArtifact],
};

export const CreateAlertResolutionNotesMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Comment, SchemaTypenames.Thread],
};

export const UpdateAlertResolutionNoteMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Comment, SchemaTypenames.Thread],
};

export const DeleteAlertResolutionNoteMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Comment, SchemaTypenames.Thread],
};

export const CreateNotebookMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Notebook],
};

export const UpdateNotebookMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Notebook],
};

export const DeleteNotebookMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.Notebook],
};

export const CreateExternalConnectionMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.ExternalConnection],
};

export const UpdateExternalConnectionMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.ExternalConnection],
};

export const DeleteExternalConnectionMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.ExternalConnection],
};

export const SendTestNotificationMutationContext: TypenamesContext = {
  additionalTypenames: [],
};

export const CreateSyntheticTestMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.SyntheticTest],
};

export const UpdateSyntheticTestMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.SyntheticTest],
};

export const DeleteSyntheticTestMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.SyntheticTest],
};

export const CreateSyntheticVariableMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.SyntheticGlobalVariable],
};

export const UpdateSyntheticVariableMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.SyntheticGlobalVariable],
};

export const DeleteSyntheticVariableMutationContext: TypenamesContext = {
  additionalTypenames: [SchemaTypenames.SyntheticGlobalVariable],
};
